import * as logService from "./services/logs";
import { loggedIn } from "./services/auth";
// const toast = require("../toast");

class WidgetUtils {
  constructor(component, timeLimit, timeUsed, mode) {
    this.component = component;
    this.allowedTime = timeLimit;
    this.widgets_interval = null;
    this.totalTime = timeUsed;
    this.refreshMsgTime = 0;
    this.loggedIn = loggedIn();
    this.mode = mode;
    this.setIntervalWidgets();
    this.utils = new Utils();
    this.utils.initializeUtils();
  }

  // Set Interval for 10 secs
  setIntervalWidgets() {
    let self = this;
    this.widgets_interval = setInterval(function () {
      self.totalTime += 10000;
      self.refreshMsgTime += 10000;
      if (self.refreshMsgTime >= 7200000) {
        // toast.showSuccessToast(
        //   "The app has been running for 2+ hours. Please refresh to get the best experience!"
        // );
      }
      if (self.mode === "F" && self.checkTimeLimitReached()) {
        clearInterval(self.widgets_interval);
        self.component.setState({
          limitReached: true,
          widgetStarted: false,
          widgetStopped: true,
        });
        self.utils.resetPianoKeys();
        console.log("Limit reached");
        // toast.showErrorToast("Limit reached!");
        self.component.toggleUpgradeModal();
      }

      logService
        .logTime(self.totalTime)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }, 10000);
  }

  checkTimeLimitReached() {
    return this.totalTime >= this.allowedTime ? true : false;
  }

  clearWidgetInterval() {
    clearInterval(this.widgets_interval);
    this.utils.resetPianoKeys();
  }
}

class Utils {
  constructor() {
    this.initializeUtils();
  }

  initializedWidgets(widgets, timeLimit, timeUsed, mode) {
    this.widgets = new WidgetUtils(widgets, timeLimit, timeUsed, mode);
  }

  initializeUtils() {
    this.resetPianoKeys = function () {
      let highlighted = document.querySelectorAll(
        ".react-piano-key-highlighted"
      );
      let vocalDivs = document.querySelectorAll(".vocal-arrow");
      let overBridge = document.querySelectorAll(
        ".react-piano-key-highlighted .over-bridge"
      );
      let underBridge = document.querySelectorAll(
        ".react-piano-key-highlighted .under-bridge"
      );
      let bridge = document.querySelectorAll(".bridge");
      let pressed = document.querySelectorAll(".react-piano-key-pressed");
      let bgChanged = document.querySelectorAll(
        ".react-piano-key[highlighted=true]"
      );
      highlighted.forEach((key) => {
        key.classList.remove("react-piano-key-highlighted");
      });
      vocalDivs.forEach((key) => {
        key.classList.remove("highlighted");
      });
      pressed.forEach((key) => {
        key.classList.remove("react-piano-key-pressed");
      });

      overBridge.forEach((key) => {
        key.classList.remove("over-bridge");
      });

      underBridge.forEach((key) => {
        key.classList.remove("under-bridge");
      });

      bridge.forEach((key) => {
        key.classList.remove("bridge");
      });

      bgChanged.forEach((key) => {
        key.style.backgroundColor = "";
      });
    };
  }
}

export default Utils;
